import BackgroundMusicManagement from "./background-music-management.page";

export default BackgroundMusicManagement;
